import router from './router/router';
import store from './store'
const whiteList = ['/404', '/401', '/lock', '/login', '/register', '/mobile/login', '/switchlogout'];
const loginRG = /\/[a-zA-Z0-9]*\/login$/;
import { MessageBox } from 'element-ui';
import { validatenull } from '@/util/validate';

router.beforeEach(async (to, from, next) => {
  if (to.path === '/login') {
    store.dispatch('ClearCache');
  }
  if (store.getters.accessToken) {
    if (whiteList.indexOf(to.path) == -1) {
      const { permissionAddRoutes } = store.getters;
      if (validatenull(permissionAddRoutes)) {
        store.dispatch('permission/addGenerateRoutes')
      }
      next();
    } else {
      next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1 || loginRG.test(to.path)) {
      next();
    } else {
      next('/login')
    }
  }
});


router.afterEach((to, from) => {
    if (to.path !== '/login') {
        const {updatePassword, updatePasswordData} = store.getters.userInfo;
        if (updatePassword === true) {
            MessageBox.alert(updatePasswordData, '修改密码提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                    if (action === 'cancel') {
                        next('/login');
                    } else {
                        store.commit('SHOW_UPDATE_PASSWORD', true);
                    }
                }
            });
            return;
        }
    }
});
